export const ResetIcon = () => {
  return (
    <svg
      width="55"
      height="55"
      viewBox="0 0 55 55"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.5 28C15.5 30.8919 16.5027 33.6944 18.3374 35.9299C20.172 38.1654 22.725 39.6956 25.5614 40.2598C28.3977 40.824 31.342 40.3873 33.8925 39.024C36.4429 37.6608 38.4418 35.4553 39.5485 32.7835C40.6552 30.1117 40.8012 27.1389 39.9618 24.3714C39.1223 21.604 37.3492 19.2133 34.9446 17.6066C32.5401 16 29.6528 15.2767 26.7748 15.5602C23.8968 15.8437 21.2061 17.1163 19.1612 19.1612"
        stroke="black"
        stroke-width="5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <circle cx="28" cy="28" r="10" fill="#E5CFAB" />
      <path
        d="M17.6759 13.4679L17.8828 21.3019C17.887 21.4632 18.0181 21.5922 18.1794 21.594L25.7921 21.6762"
        stroke="black"
        stroke-width="5"
        stroke-linecap="round"
      />
    </svg>
  );
};
